<template>
  <div class="headTop" id="headTop">
    <div class="mintop">
      <div id="mobile_header" v-bind:class="topshow2">
        <a class="mhlogo" @click="gotoindx()" id="ucNavigator_mobile_uiHref_logo">
          <img src="../assets/logo.png" id="drop_nav_logo2" alt="logo" />
        </a>
        <i
          class="fa fa-times"
          :class="haveto"
          :data-type="mnav_type"
          @click="getlist($event)"
          id="nav_icon2"
        ></i>
        <div class="clear"></div>

        <div :class="mnavshow" id="mobile_nav" style=" top: 66px; ">
          <ul>
            <li v-for="(item, index) in categoryList" :key="index">
              <a @click.stop="navTo(item)">
                <span id="ucNavigator_mobile_uiTag_Services" langargument="Common,Tag,281">{{item.name}}</span>
                <template v-if="(item.children && item.children.length > 0) || item.id == 4">
                  <span v-if="item.id == 4" @click.stop="getmore1()" class="more">{{moreshow1?"+":"x"}}</span>
                  <span v-else @click.stop="getmorec()" class="more">{{moreshow?"+":"x"}}</span>
                </template>
              </a>
              <ul v-if="(item.children && item.children.length > 0)" class="produtul" :class='moreshow?"mtani1":"mtani"'>
                <li v-for="(child, chdIdx) in item.children" :key="chdIdx">
                  <a @click="navTo(child)" id="ucNavigator_mobile_uiHref_Warranty">
                    <span id="ucNavigator_mobile_uiTag_Warranty" langargument="Common,Tag,282">{{child.name}}</span>
                  </a>
                </li>
              </ul>
              <ul v-if="item.id == 4" :class='moreshow1?"mtani1":"mtani2"'>
                <li v-for="(child, chdIdx) in productType" :key="chdIdx">
                  <a @click="goProduct(item.id, child.id)" id="ucNavigator_mobile_uiHref_Warranty">
                    <span id="ucNavigator_mobile_uiTag_Warranty" langargument="Common,Tag,282">{{child.name}}</span>
                  </a>
                </li>
              </ul>
            </li>

          </ul>
        </div>
      </div>
    </div>
    <div id="drop_nav" v-bind:class="topshow">
      <div class="dropWrapper">
        <a class="toplogo" @click="gotoindx()" id="ucNavigator_drop_uiHref_logo">
          <img src="../assets/logo.png" id="drop_nav_logo" alt="logo" />
        </a>
        <nav id="nav">
          <ul>
            <li v-for="(item, index) in categoryList" :key="index">
              <a @click="navTo(item)" id="ucNavigator_drop_uiHref_Technology">
                <b>
                  <span id="ucNavigator_drop_uiTag_Technology" langargument="Common,Tag,271">{{item.name}}</span>
                </b>
              </a>
              <div v-if="item.children && item.children.length > 0" class="submenu">
                <div class="col">
                  <div v-for="(child, chdIdx) in item.children" :key="chdIdx">
                    <a @click="navTo(child)">{{child.name}}</a>
                  </div>
                </div>
              </div>
              <div v-if="item.id == 4" class="submenu">
                <div class="col">
                  <div v-for="(child, chdIdx) in productType" :key="chdIdx">
                    <a @click="goProduct(item.id, child.id)">{{child.name}}</a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <!-- <div class="topbar">
      <div class="topleft">
        <img src="../assets/btn_search.png" alt />
      </div>
      <div class="topright">
        <a>
          <i class="i_one"></i>
          <span>MYINNODISK</span>
        </a>
        <a>
          <i class="i_two"></i>
          <span>询问单</span>
        </a>
        <a>
          <i class="i_three"></i>
          <span>关于我们</span>
        </a>
        <a>
          <i class="i_four"></i>
          <span>语系</span>
        </a>
      </div>
    </div> -->
    <div class="mintop">
      <div class="wrapper" style="display:none">
        <a class="logom" @click="gotoindx()" id="ucHeader_uiHref_logo">
          <img src="../assets/logo.png" id="logo" alt="logo" />
        </a>

        <i class="fa fa-bars" @click="getlist1()" id="nav_icon"></i>

        <div :class="navshow?'mtani3':'mtani1'" id="mobile_nav" style=" top: 126px; ">
          <ul>
            <li v-for="(item, index) in categoryList" :key="index"  >
              <a @click.stop="navTo(item)">
                <span id="ucNavigator_mobile_uiTag_Services" langargument="Common,Tag,281">{{item.name}}</span>
                <template v-if="(item.children && item.children.length > 0) || item.id == 4">
                  <span v-if="item.id == 4" class="more">{{moreshow1?"+":"x"}}</span>
                  <span v-else @click.stop="getmorec()" class="more">{{moreshow?"+":"x"}}</span>
                </template>
              </a>
              <ul v-if="(item.children && item.children.length > 0)" class="produtul" :class='moreshow?"mtani1":"mtani"'>
                <li v-for="(child, chdIdx) in item.children" :key="chdIdx">
                  <a @click="navTo(child)" id="ucNavigator_mobile_uiHref_Warranty">
                    <span id="ucNavigator_mobile_uiTag_Warranty" langargument="Common,Tag,282">{{child.name}}</span>
                  </a>
                </li>
              </ul>
              <ul v-if="item.id == 4" :class='moreshow1?"mtani1":"mtani2"'>
                <li v-for="(child, chdIdx) in productType" :key="chdIdx">
                  <a @click="goProduct(item.id, child.id)" id="ucNavigator_mobile_uiHref_Warranty">
                    <span id="ucNavigator_mobile_uiTag_Warranty" langargument="Common,Tag,282">{{child.name}}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="topbox">
      <div class="topnav" ref="element">
        <a @click="gotoindx()">
          <img id="logo" src="../assets/logo.png" alt />
        </a>
        <ul>
          <li v-for="(item, index) in categoryList" :key="index">
            <a @click="navTo(item)">
              <b>
                <span id="ucHeader_uiTag_Applications" langargument="Common,Tag,251">{{item.name}}</span>
              </b>
              <br />
              <span id="ucHeader_uiTag_Technology_desc" langargument="Common,Tag,272">
                {{item.categorySynopsis}}
              </span>
            </a>
            <div v-if="item.children && item.children.length > 0" class="submenu">
              <div class="col">
                <div v-for="(child, chdIdx) in item.children" :key="chdIdx">
                  <a @click="navTo(child)">{{child.name}}</a>
                </div>
              </div>
            </div>
            <div v-if="item.id == 4" class="submenu">
              <div class="col">
                <div v-for="(child, chdIdx) in productType" :key="chdIdx">
                  <a @click="goProduct(item.id, child.id)">{{child.name}}</a>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getCategoryTree } from '@/api/content.js'
import { getAllProductType, getProductList, getProductTypeByPid } from '@/api/product.js'
export default {
  name: "headTop",
  data() {
    return {
      topshow: "",
      topshow2: "",
      mnav_type: "1",
      haveto: "",
      mnavshow: false,
      moreshow: true,
      moreshow1: true,
      navshow: false,
      categoryList: [],
      productType: []
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getCategory()
    // 查询产品系列
    this.getAllProductType()
  },
  methods: {
    getCategory() {
      getCategoryTree().then(res => {
        if (res.code !== 200) return
        this.categoryList = res.data
      })
    },
    getAllProductType() {
      getAllProductType().then(res => {
        if (res.code !== 200) return
        this.productType = res.data
      })
    },
    navTo(item) {
      if(item.id==5||item.id==4){
        this.$notify.info({
          title: '提示',
          message: '系统维护中...'
        });
        return
      }

      if (item.children && item.children.length > 0){
           if(item.id==6){
          this.moreshow = !this.moreshow;
          }
      } else{
        if(item.id==4){
            this.moreshow1 = !this.moreshow1;
          }else{


        this.$router.push({ path: item.categoryHtml, query: { categoryId: item.id } });
//移动端头部组件跳转页面未关闭导航栏，以下关闭导航栏
        this.navshow = false;
         this.mnav_type = 1;
        this.haveto = "";
        this.mnavshow = "mtani1";
        this.moreshow=true;
        this.moreshow1=true
         }
      }


    },
    gotoindx() {
      this.$router.push("/");
      window.location.reload();
    },
    goProduct(categoryId, typeId) {
      if(categoryId==4){
        this.$notify.info({
          title: '提示',
          message: '系统维护中...'
        });
        return
      }

      getProductTypeByPid(typeId).then((res) => {
        if (res.code !== 200) return;
        let childTypeList = res.data;
        if (!childTypeList || childTypeList.length == 0) {
          let params = {
            size: 2,
            current: 1,
            productType: typeId,
          };
          getProductList(params).then((res) => {
            if (res.code !== 200) return;
            let productList = res.data.records;
            if (productList && productList.length == 1) {
              this.$router.push({
                path: "/proDetail",
                query: { id: productList[0].id, categoryId: categoryId },
              });
              window.location.reload();
            } else {
              this.$router.push({ path: '/products', query: { categoryId: categoryId, typeId: typeId } });
              window.location.reload();
            }
          });
        } else {
          this.$router.push({ path: '/products', query: { categoryId: categoryId, typeId: typeId } });
          window.location.reload();
        }

      });

    },
    gototcl: function () {
      this.$router.push("/technology");
      window.location.reload();
    },
    gotopro() {
      this.$router.push("/products");
      window.location.reload();
    },
    gotoser() {
      this.$router.push("/service");
      window.location.reload();
    },
    gotopdel(e) {
      this.$router.push({ path: "/products", query: { type: e } });
      window.location.reload();
    },
    gotocclu() {
      this.$router.push("/cculture");
      window.location.reload();
    },
    gotonew() {
      this.$router.push("/cnews");
      window.location.reload();
    },
//滚动条到顶部的距离超出导航难，悬浮导航栏出现
    handleScroll() {
      // var div_height = this.$refs.element.offsetHeight;
      var bwidth = document.documentElement.clientWidth;
      var div_height = 100;
      if (document.documentElement.scrollTop > div_height) {
        // console.log(bwidth);
        if (bwidth > 1300) {
          this.topshow = "drop";
          // console.log(this.topshow);
        } else if (bwidth <= 1300) {
          // console.log(2);
          this.topshow2 = "drop";
           this.moreshow=true;
        this.moreshow1=true
        }
      } else {
        this.topshow = "";
        this.topshow2 = "";
          this.navshow = false;
         this.mnav_type = 1;
        this.haveto = "";
        this.mnavshow = "mtani1";

      }
    },
//移动端点击出现导航难
    getlist(e) {
      console.log(e.currentTarget.getAttribute("data-type"));
      var type = e.currentTarget.getAttribute("data-type");
      if (type == 1) {
        this.mnav_type = 2;
        this.haveto = "haveto";
        this.mnavshow = "mtani";
      } else if (type == 2) {
        this.mnav_type = 1;
        this.haveto = "";
        this.mnavshow = "mtani1";
        this.moreshow=true;
        this.moreshow1=true
      }
    },
    getlist1() {
      if (this.navshow) {
        this.navshow = false;
        this.moreshow=true;
        this.moreshow1=true
      } else {
        this.navshow = true;
      }
    },
    getmorec() {
      this.moreshow = !this.moreshow
    },
    getmore1() {
      this.moreshow1 = !this.moreshow1
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mtani3 {
  top: 100px;
  height: 245px !important;
  transition: height 0.3s linear !important;
}
.mtani {
  height: 245px !important;
  transition: height 0.3s linear !important;
}
.mtani1 {
  height: 0px !important;
  transition: height 0.3s linear !important;
}
.mtani2 {
  height: 200px !important;
  transition: height 0.3s linear !important;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.mintop .wrapper {
  margin: auto;
  box-sizing: border-box;
  padding: 35px 40px 0;
  overflow: hidden;
}

.mintop .wrapper #nav_icon {
  display: block;
  background: url(../assets/caidan.png) no-repeat;
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  float: right;
  margin-top: 20px;
}
.mintop .wrapper .logom {
  float: left;
  width: 140px;
  height: auto;
}
.mintop .wrapper .logom img {
  width: 100%;
  height: auto;
}

@media screen and (max-width: 1300px) {
  .mintop .wrapper {
    width: 100%;
    display: block !important;
  }
}

@media screen and (max-width: 1300px) {
  .mintop .wrapper {
    padding: 35px 40px;
  }
}

@media screen and (max-width: 1200px) {
  #logo {
    width: 140px;
    margin-top: 0;
  }
}
@media screen and (max-width: 1200px) {
  .drop_nav {
    display: none;
  }
}
@media screen and (max-width: 1200px) {
  #nav_icon {
    display: block;
  }
}
@media screen and (max-width: 1200px) {
  #mobile_header {
    display: block !important;
    padding: 10px 40px;
  }
}
#drop_nav_logo2 {
  width: 110px;
}
#mobile_header {
  display: none;
  position: fixed;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  top: -100px;
  z-index: 100;
  background-color: #fff;
  box-shadow: 0 5px 5px -1px rgba(0, 0, 0, 0.3);
  transition: top 0.3s linear;
}
#mobile_header .mhlogo {
  width: 145px;
  height: auto;
  float: left;
}
#mobile_header #nav_icon2 {
  display: block;
  background: url(../assets/caidan.png) no-repeat;
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  float: right;
  margin-top: 8px;
}
.haveto {
  background: url(../assets/quxiao-kuai.png) no-repeat !important;
  background-size: 100% 100% !important;
}
@media screen and (max-width: 1300px) {
  #mobile_nav {
    position: absolute;
    width: 100%;
    top: 265px;
    left: 0;
    z-index: 100;
    height: 0;
    /* display: none; */
  }
}

#mobile_nav ul {
  margin: 0;
  padding: 0;
  background-color: #16272e;
}
#mobile_nav {
  height: 0;
  /* display: none; */
  overflow-y: scroll;
  overflow-x: hidden;
}
#mobile_nav ul li {
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #16272e;
  list-style-type: none;
  border-bottom: 1px #888 solid;
  font-size: 18px;
}
@media screen and (max-width: 1200px) {
  #mobile_nav ul li a {
    color: #fff;
    padding: 12px 40px;
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
    font-family: latowebbold;
  }
}
#mobile_nav ul li a {
  color: #fff;
  padding: 12px 20px;
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  font-family: latowebbold;
}
#mobile_nav ul li a .more {
  float: right;
}
#mobile_nav ul ul {
  height: 0;
  overflow: hidden;
}
#mobile_nav ul li li {
  background-color: #5e676c;
}
#mobile_nav ul li li a {
  color: #14252c;
}
@media screen and (max-width: 1200px) {
  #mobile_nav ul li a {
    color: #fff;
    padding: 12px 40px;
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
    font-family: latowebbold;
  }
}
#nav_icon2 {
  float: right;
  color: #15262e;
  margin-top: 10px;
  font-size: 30px;
}
.fa {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.drop {
  display: block!important;
  top: 0 !important;
  transition: top 0.3s linear !important;
}
.toplogo {
  float: left;
}
#drop_nav {
  position: fixed;
  width: 100%;
  padding: 5px 40px 0px;
  box-sizing: border-box;
  top: -100px;
  z-index: 90;
  background-color: #fff;
  box-shadow: 0 5px 5px -1px rgba(0, 0, 0, 0.3);
  transition: top 0.3s linear;
}
#drop_nav .dropWrapper {
  width: 1280px;
  margin: 0 auto;
  box-sizing: border-box;
}
#drop_nav #drop_nav_logo {
  width: 110px;
}
#drop_nav nav#nav {
  margin: 10px 40px 0 0;
}
nav#nav {
  float: right;
  position: relative;
  margin: 19px 40px 0 0;
}
nav#nav ul {
  margin: 0;
  padding: 0;
}
#drop_nav nav#nav ul li {
  text-align: left;
  padding: 8px 10px 10px 15px;
  background: url(../assets/nav_border2.png) left top no-repeat;
}
nav#nav ul li {
  position: relative;
  margin: 0;
  padding: 8px 10px 43px 15px;
  list-style: none;
  display: inline-block;
  width: 187px;
  border-bottom: 3px #fff solid;
  background: url(../assets/nav_border.png) left top no-repeat;
}
nav#nav ul li:hover {
  border-bottom: 3px #146cbd solid;
}
nav#nav ul li a {
  padding: 3px 0;
  text-decoration: none;
  color: #146cbd;
  line-height: 100%;
  font-family: latoweblight;
}
#drop_nav nav#nav ul li .submenu {
  position: absolute;
  left: 0;
  top: 37px;
  font-family: latowebbold;
  z-index: 4;
  background-color: #15262e;
  color: #fff;
  line-height: 24px;
  padding: 5px;
  box-sizing: border-box;
  display: none;
}
#drop_nav nav#nav ul li:hover .submenu {
  display: block;
}
#drop_nav nav#nav ul li .submenu.first {
  width: 421px;
}
nav#nav ul li .submenu .col {
  width: 203px;
  padding: 10px;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;
}
nav#nav ul li .submenu .col a {
  color: #fff;
}
.topbar {
  width: 100%;
  padding: 10px 20px;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;
  background: #dde2e6;
}
.topleft {
  cursor: pointer;
  float: left;
  width: 20px;
  height: 20px;
}
.topleft img {
  width: 100%;
  height: 100%;
}
.topright {
  float: right;
}
@media screen and (max-width: 760px) {
  .topright a:nth-child(3) {
    display: none;
  }
}
@media screen and (max-width: 760px) {
  .topright a:nth-child(4) {
    display: none;
  }
}
.topright a {
  padding-right: 15px;
  color: #585757;
  font-size: 11px;
  font-family: latowebbold;
  font-weight: 400;
  letter-spacing: 1px;
}
.topright a i {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;

  background-size: 100% auto;
  text-align: center;
  color: #fff;
  font-style: normal;
}
.topright a .i_one {
  background: url(../assets/nav_top1.png) no-repeat top;
}
.topright a:hover .i_one {
  background: url(../assets/nav_top1.png) no-repeat bottom;
}
.topright a .i_two {
  background: url(../assets/nav_top2.png) no-repeat top;
}
.topright a:hover .i_two {
  background: url(../assets/nav_top2.png) no-repeat bottom;
}
.topright a .i_three {
  background: url(../assets/nav_top3.png) no-repeat top;
}
.topright a:hover .i_three {
  background: url(../assets/nav_top3.png) no-repeat bottom;
}
.topright a .i_four {
  background: url(../assets/nav_top4.png) no-repeat top;
}
.topright a:hover .i_four {
  background: url(../assets/nav_top4.png) no-repeat bottom;
}
.topright a:hover span {
  color: red;
}
@media screen and (max-width: 1300px) {
  .topbox {
    display: none;
  }
}
.topbox {
  width: 100%;
  background-color: #fff;
  /* overflow: hidden; */
}
.topbox .topnav {
  width: 1280px;
  height: 170px;
  padding: 35px 20px 0;
  margin: 0 auto;
  box-sizing: border-box;
  /* overflow: hidden; */
}
.topbox .topnav a #logo {
  float: left;
  width: 200px;
  margin-top: 10px;
}
.topbox .topnav ul {
  float: right;
  position: relative;
  margin: 19px 10px 0 0;
  display: flex;
}
.topbox .topnav ul li {
  text-align: left;
  position: relative;
  margin: 0;
  padding: 8px 10px 43px 15px;
  list-style: none;
  display: inline-block;
  width: 170px;
  border-bottom: 3px #fff solid;
  background: url(../assets/nav_border.png) left top no-repeat;
}
.topbox .topnav ul li:hover {
  border-bottom: 3px #146cbd solid;
}
.topbox .topnav ul li:hover div {
  display: block;
}
.topbox .topnav ul li a {
  padding: 3px 0;
  text-decoration: none;
  color: #15262e;
  line-height: 100%;
  font-family: latoweblight;
}
.topbox .topnav ul li a b {
  display: inline-block;
  color: #146cbd;
  font-family: latowebbold;
  font-weight: bold;
  padding-bottom: 8px;
  font-size: 15px;
}
.topbox .topnav ul li .submenu {
  position: absolute;
  top: 100px;
  left: -1px;
  z-index: 9999;
  background-color: #15262e;
  color: #fff;
  line-height: 24px;
  padding: 5px;
  box-sizing: border-box;
  display: none;
}

.topbox .topnav ul li .submenu.first {
  width: 421px;
}
.topbox .topnav ul li .submenu .col {
  width: 203px;
  padding: 10px;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;
}
.topbox .topnav ul li .submenu .col a {
  color: #fff;
}
@media screen and (max-width: 1200px) {
  .swiper-container {
    height: 350px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue